import { doc, setDoc } from 'firebase/firestore';
import { db, logAdminActivity } from '../lib/firebase';

export const toggleContestStatus = async (ended: boolean): Promise<void> => {
  const contestRef = doc(db, 'settings', 'contest-status');
  const now = new Date();
  
  await setDoc(contestRef, {
    ended,
    ...(ended ? { endedAt: now } : {}),
    lastUpdated: now
  });

  await logAdminActivity(ended ? 'end_contest' : 'start_contest', {
    timestamp: now,
    action: ended ? 'Contest ended' : 'Contest started'
  });
};